import React from 'react'
import TopBar from './topBar'

export default function CoronavirusNotice() {
  return <TopBar className={'coronavirus-notice-bar'}>
    <span className={'text'}>COVID-19 Advisory: Isha Institute Currently Closed.</span>
    <a
      href='https://isha.sadhguru.org/us-en/covid-19-advisory/'
      target={'_blank'}
      rel={'noreferrer noopener'}
      className={'button'}
    >
      Details
    </a>
  </TopBar>
}


// WEBPACK FOOTER //
// ./src/components/topBars/coronavirusNotice.js